"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOnMarket$ = exports.TimeOnMarket$outboundSchema = exports.TimeOnMarket$inboundSchema = void 0;
exports.timeOnMarketToJSON = timeOnMarketToJSON;
exports.timeOnMarketFromJSON = timeOnMarketFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.TimeOnMarket$inboundSchema = z.object({
    average_days_on_market: z.number().int(),
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_days_on_market": "averageDaysOnMarket",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.TimeOnMarket$outboundSchema = z.object({
    averageDaysOnMarket: z.number().int(),
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageDaysOnMarket: "average_days_on_market",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TimeOnMarket$;
(function (TimeOnMarket$) {
    /** @deprecated use `TimeOnMarket$inboundSchema` instead. */
    TimeOnMarket$.inboundSchema = exports.TimeOnMarket$inboundSchema;
    /** @deprecated use `TimeOnMarket$outboundSchema` instead. */
    TimeOnMarket$.outboundSchema = exports.TimeOnMarket$outboundSchema;
})(TimeOnMarket$ || (exports.TimeOnMarket$ = TimeOnMarket$ = {}));
function timeOnMarketToJSON(timeOnMarket) {
    return JSON.stringify(exports.TimeOnMarket$outboundSchema.parse(timeOnMarket));
}
function timeOnMarketFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TimeOnMarket$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TimeOnMarket' from JSON`);
}
//# sourceMappingURL=timeonmarket.js.map